import Nullstack from 'nullstack';
export default function IconTornado({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-tornado",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "21",
    y1: "4",
    x2: "3",
    y2: "4"
  }), "   ", Nullstack.element("line", {
    x1: "13",
    y1: "16",
    x2: "7",
    y2: "16"
  }), "   ", Nullstack.element("line", {
    x1: "11",
    y1: "20",
    x2: "15",
    y2: "20"
  }), "   ", Nullstack.element("line", {
    x1: "6",
    y1: "8",
    x2: "20",
    y2: "8"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "12",
    x2: "16",
    y2: "12"
  }), " ");
}